module.exports = __webpack_public_path__ + "static/media/upload-img-new.048d0ac1.svg";